/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateMerchantTwoFactorState} from '../api'

export const useMutationUpdateMerchantTwoFactorState = createReactQueryMutationHook('updateMerchantTwoFactorState', updateMerchantTwoFactorState)
